<template>
  <div class="settings_right">
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'"
            icon-pack="feather"
            icon="icon-search"
            v-model="searchtxt"
            placeholder="Search by SOC"
            class="is-label-placeholder"
          />
        </div>
      </div>
      <div class="content-header-right">
      <vs-inv-dropdown >
        <!-- <vs-dropdown  vs-custom-content vs-trigger-click>
          <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
            icon-after>
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content"> -->
           <div class="filters-content colone">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">
                  <div class="vx-col w-full con-select">
                    <label class="typo__label">Select Status</label>
                              
                    <multiselect v-model="selectedStatus" :options="statusList" :multiple="false" :hideSelected="true"
                      :close-on-select="true" :clear-on-select="false" :select-label="''" :preserve-search="false"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                      
                       <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Status selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                      </template>
                    </multiselect>
                  </div>

                </div>
              </div>  
            </div>  

            <div class="filters-status">
              <div class="left-buttons">
                
              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" vs-trigger-click v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" vs-trigger-click v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
            </div>
          <!-- </vs-dropdown-menu> -->
        <!-- </vs-dropdown> -->
      </vs-inv-dropdown>

        

        <vs-button
          type="border"
         
          class="light-blue-btn"
          @click="showBulkUpload()"
          >Bulk Upload<span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </vs-button>
     
        <vs-button
          type="border"
         
          class="light-blue-btn"
          @click="addNew()"
          >Add SOC<span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </vs-button>
      </div>
    </div>
    <!--- You haven\'t  created any User Roles yet. Create a User Roles to start using the ImmiBox ---->
    <NoDataFound
      ref="NoDataFoundRef" 
      v-if="list.length == 0"
      :content="callFromSerch ? '' : ''"
      :heading="callFromSerch ? 'No Results Found' : 'No Case Types Found'"
      type="User Roles"
    />

    <div class="accordian-table" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="list.length > 0">
          <vs-th>
            <a
              @click="sortMe('name')"
              v-bind:class="{
                sort_ascending: sortKeys['name'] == 1,
                sort_descending: sortKeys['name'] != 1,
              }"
            >
              SOC
            </a>
          </vs-th>
          <vs-th>Created On</vs-th>
           <vs-th>Updated On</vs-th>
           <vs-th>Status</vs-th>
          <vs-th class="actions">Actions</vs-th>
        </template>

        <template>
          <template v-for="(tr, indextr) in list">
            <vs-tr
             
              :data="tr"
              :key="indextr"
            >
              <vs-td class="td_label" :data="tr">
                 {{ checkProperty( tr,'socDetails' ,'name') }}
                 <small>{{ checkProperty( tr,'socDetails','designation') }}</small>
                </vs-td>
             <vs-td >{{tr['createdOn'] | formatDate}} </vs-td>
             <vs-td > <template v-if="checkProperty( tr,'updatedOn')">{{tr['updatedOn'] | formatDate}}</template> </vs-td>
              
             <vs-td >
              <span class="statusspan " :class="{'status_active':tr.status,'status_rejected':!tr.status}" >
              {{ tr.status?'Active':'Inactive'}}
              </span>
            </vs-td>
             <vs-td class="actions-td">
                <div class="action-icons">
                  <a @click="editMe(tr)" class="edit IB_tooltip">
                    <div class="tooltip_cnt">
                      <p>
                        Edit
                      </p>
                    </div>
                  </a>
                  <a v-if="checkProperty( tr ,'document')" @click="showViewModal(tr ,false)" class="view-eye IB_tooltip">
                    <div class="tooltip_cnt">
                      <p>
                        View
                      </p>
                    </div>
                  </a>
                  <template v-if="checkProperty( tr ,'document') && checkProperty(tr ,'document', 'length')==1 ">
                    <a  class="download IB_tooltip"   @click="downloadFile(tr['document'][0])">
                      <div class="tooltip_cnt">
                        <p>
                          Download
                        </p>
                      </div>
                    </a>
                  </template>
                  <template v-else-if="checkProperty( tr ,'document') && checkProperty(tr ,'document', 'length')>1 ">
                    <a class="download IB_tooltip"  @click="showViewModal(tr ,true)">
                      <div class="tooltip_cnt">
                        <p>
                          Download
                        </p>
                      </div>
                    </a>
                  </template>
                 
                  <a href.prevent @click="deleteSoc( true,tr)" class="active IB_tooltip" :class="{'inactive':!checkProperty(tr,'status')}">
                    <div class="tooltip_cnt">
                      <p>
                        {{checkProperty(tr,'status')?'Inactivate':'Activate'}}
                      </p>
                    </div>
                  </a>
                </div>
                <!-- <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent
                    ><more-vertical-icon
                      size="1.5x"
                      class="custom-class"
                    ></more-vertical-icon
                  ></a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item>
                      <a  style="cursor: pionter; padding: 3px 10px"  @click="editMe(tr)" >Edit</a  >
                    </vs-dropdown-item>
                     <vs-dropdown-item>
                      <a  v-if="checkProperty( tr ,'document')"  @click="showViewModal(tr)"   ><p style="cursor:pionter"  >View</p></a>
                    </vs-dropdown-item>

                   
                    <vs-dropdown-item  >
                     <a   href.prevent @click="deleteSoc( true,tr)"   ><p style="cursor:pionter"  >{{checkProperty(tr,'status')?'Inactivate ':' Activate'}}</p></a>
                   </vs-dropdown-item>
                   
                    

                 
                  </vs-dropdown-menu>
                </vs-dropdown> -->
                <!---
                <div class="table-actions">
                  <a class="edit_btn" style="cursor: pionter; padding: 3px 10px"  @click="editMe(tr)" >Edit</a  >
                
                     <a  v-if="checkProperty( tr ,'document')" class="IB_primary-btn" @click="showViewModal(tr)"   ><p style="cursor:pionter"  >View</p></a>
                   
                </div>
              -->


              </vs-td>
            </vs-tr>
          </template>
         
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="list.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true" :allow-empty="false">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate
        v-if="list.length > 0"
        v-model="page"
        :page-count="totalpages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
        :prev-text="'<i></i>'"
        :next-text="'<i></i>'"
        :container-class="'pagination vs-pagination--nav'"
        :page-class="'page-item'"
      ></paginate>
      </div>
      
    </div>



     <modal
      name="socSettingModel"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            {{ edit ? "Edit SOC Configuration" : "SOC Configuration" }}
          </h2>
          <span @click="hideModel('socSettingModel')">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent>
          <div class="form-container" @click="formerrors.msg =''">
            
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group d-block">
                  <label class="form_label">Name<em>*</em></label>
                  <vs-input :key="'Name'"
                  :disabled="edit"
                   v-model="newform.name"  
                   maxLength="15"
                    name="Name"
                    v-validate="'required'"
                    class="w-full"
                    data-vv-as="Name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Name')"
                    >{{ errors.first("Name") }}</span
                  >
                </div>
              </div>
              <div class="vx-col w-full">
                <div class="form_group d-block">
                  <label class="form_label">Designation<em>*</em></label>
                  <vs-input :key="'designation'"
                   v-model="newform.designation"  
                    name="designation"
                    v-validate="'required'"
                    class="w-full"
                    data-vv-as="Designation"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('designation')"
                    >{{ errors.first("designation") }}</span
                  >
                </div>
              </div>
              
             </div>
             
            <div class="vx-row">
            <div class="vx-col w-100" v-if="false"   >
              <div class="form_group d-block">
                <label class="form_label">SOC<em>*</em></label>
                  <div class="con-select w-full">
                 
                    <multiselect
                       name="desiredsoccode"
                      v-model="newform.socDetails"
                      :options="masterSocList"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select SOC"
                      label="name"
                      track-by="id"
                      :preselect-first="false"
                       data-vv-as="SOC"
                      v-validate="'required'"
                       
                    
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} SOC(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                    <span   class="text-danger text-sm" v-show="errors.has('desiredsoccode')"  >{{ errors.first("desiredsoccode") }}</span>
                  </div>
              </div>
            </div>
            
              <div class="vx-col w-full" >
                <div class="form_group d-block">
                  <label class="form_label">Description<em>*</em></label>
                  <!-- <vs-textarea
                    class="w-full"
                    v-model="newform.description" 
                    v-validate="'required'"
                    data-vv-as="Description"
                    name="description"
                  /> -->
                  <ckeditor  class="w-full"
                    v-model="newform.description" 
                    v-validate="'required'"
                    data-vv-as="Description"
                    name="description"  :editor="editor" :config="editorConfig"></ckeditor>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('description')"
                    >{{ errors.first("description") }}</span
                  >
                </div>
              </div>

              <div class="vx-col w-full" >
                <div class="form_group d-block">
                  <label class="form_label">Job Titles<em>*</em></label>
                  <!-- <vs-textarea
                    class="w-full"
                    v-model="newform.jobTitles" 
                    v-validate="'required'"
                    data-vv-as="Job Titles"
                    name="jobTitles"
                  /> -->
                  <ckeditor  class="w-full"
                    v-model="newform.jobTitles" 
                    v-validate="'required'"
                    data-vv-as="Job Titles"
                    name="jobTitles" :editor="editor" :config="editorConfig"></ckeditor> 
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('jobTitles')"
                    >{{ errors.first("jobTitles") }}</span
                  >
                </div>
              </div>
 
               <div class="vx-col w-full" @click="value =[] ;uploading=false"  >
                <div class="form_group file_group  d-block">
                  <label class="form_label">Templates</label>
                  <div class="vs-component relative">
                     
                    <file-upload v-model="value" class="file-upload-input upload_file justify-center" :accept="acceptedFiles" :name="'socDocumentsUpload'" :multiple="true" 
                    :uploadction="'uploadLocal'"
                    @updateData="updateData"
                       data-vv-as="File"   
                    >
                    <!-- @input="upload(value)" -->
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                        Upload
                        
                    </file-upload>
                    <!-- <input type="hidden" data-vv-as="File"  v-model="newform.document"   v-validate="'required'" :name="'socDocuments'"  >
                     <span class="text-danger text-sm" v-show="errors.has('socDocuments')">{{ errors.first("socDocuments") }}</span>
                     <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif"></span>    -->
                  </div>
                 
                  <ul class="uploaded-list">
                      <template v-for="(item, index) in newform.document">
                          <vs-chip @click="remove(item, newform.document ,index)" :key="index" closable v-if="item.status !== false  && item.name !== null  && item.path !== null  && item.path !== ''">
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </ul>
                </div>
             </div>
            
           </div>
<!----
           <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group d-block">
                  <label class="form_label">Available Tags</label>

                   <ul class="uploaded-list available_list">
                        <template v-for="(item, index) in allTags">
                        <li :key="index" @click="copyTag(item)" >
                         {{ item}}
                          </li>
                          
                        </template>
                      </ul>      
                  
                </div>
              </div>
             </div>
--->

          
            <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                  <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >{{ formerrors.msg }}</vs-alert>
            </div>
             
              
          </div>

           
          <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideModel();  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >

            <vs-button
              :disabled="creatingNew"
              v-if="edit"
              color="success"
              class="save"
              @click="updateAction()"
              type="filled"
              >Update</vs-button
            >

            <vs-button
              :disabled="creatingNew"
              v-else
              color="success"
              class="save"
              @click="createNewAction()"
              type="filled"
              >Save</vs-button
            >
          </div>
        </form>
      </div>


       
        </modal>
 
        <modal
      name="socSettigsbulkUpload"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            Bulk Upload
          </h2>
          <span @click="hideModel('socSettigsbulkUpload')">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent>
          <div class="form-container" @click="formerrors.msg =''">
            <div class="vx-row">
           
              
 
               <div class="vx-col w-full" @click="value =[] ;uploading=false"  >
                <div class="form_group file_group  d-block">
                  <label class="form_label">File<em>*</em></label>
                  <div class="vs-component relative">
                     
                    <file-upload v-model="value" class="file-upload-input upload_file justify-center" :accept="acceptedFiles" :name="'socDocumentsUpload'" :multiple="true" 
                    :uploadction="'uploadLocal'"
                    @updateData="updateData"
                       data-vv-as="File"   
                    >
                    <!-- @input="upload(value)" -->
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                        Upload
                        
                    </file-upload>
                    <input type="hidden" data-vv-as="File"  v-model="newform.document"   v-validate="'required'" :name="'socDocuments'"  >
                     <span class="text-danger text-sm" v-show="errors.has('socDocuments')">{{ errors.first("socDocuments") }}</span>
                     <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif"></span>   
                  </div>
                 
                  <ul class="uploaded-list">
                      <template v-for="(item, index) in newform.document">
                          <vs-chip @click="remove(item, newform.document ,index)" :key="index" closable v-if="item.status !== false  && item.name !== null  && item.path !== null  && item.path !== ''">
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </ul>
                </div>
             </div>
            
           </div>


          
            <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                  <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >{{ formerrors.msg }}</vs-alert>
            </div>
             
              
          </div>

           
          <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideModel('socSettigsbulkUpload');  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >

           

            <vs-button
              :disabled="creatingNew"
           
              color="success"
              class="save"
              @click="bulkUploadAction()"
              type="filled"
              >Upload</vs-button
            >
          </div>
        </form>
      </div>


       
        </modal>
 


 <modal
      name="socSettingview"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 v-if="showSocDocs" class="popup-title">SOC Configuration Documents</h2>
          <h2 v-else class="popup-title">SOC Configuration Details</h2>
          <span @click="hideViewModal()">
            <em class="material-icons">close</em>
          </span>
        </div>
       
          <div class="form-container">
            <div class="vx-row">
              <template v-if="!showSocDocs">
              <div class="vx-col w-1/2">
                <div class="form_group  d-block ">
                  <label class="form_label">Name</label>
                  <span> {{ checkProperty(selectedItem ,'socDetails' ,'name') }}</span>
                  </div>
              </div>
              <div class="vx-col w-1/2">
                <div class="form_group  d-block ">
                  <label class="form_label">Designation</label>
                  <span> {{ checkProperty(selectedItem ,'socDetails' ,'designation') }}</span>
                  </div>
              </div> 
              <div class="vx-col w-full">
                <div class="form_group  d-block">
                  <label class="form_label">Description</label>
                  <span v-html="checkProperty(selectedItem ,'socDetails' ,'description')"></span>
                  </div>
              </div>  
              
              <div class="vx-col w-full">
                <div class="form_group  d-block">
                  <label class="form_label">Job Titles</label>
                  <span v-html="checkProperty(selectedItem ,'socDetails' ,'jobTitles') "></span>
                  </div>
              </div> 
            </template>
            <template >
              <div class="vx-col w-full" v-if="checkProperty(selectedItem ,'document' ,'length')>0">
                <div class="form_group  d-block">
                  <label class="form_label">Templates</label>
                  <ul class="uploaded-files socSettings">
                      <template v-for="(item, index) in selectedItem.document">
                          <li class="cursor-pointer" @click="downloadFile(item)" :key="index"  v-if="item.status !== false  && item.name !== null  && item.path !== null  && item.path !== ''" v-tooltip.top-center="checkProperty(item ,'name') ">
                             <docType :downloadMe="false" :item="item"/>
                             <span class="download_icon"></span>
                          </li>
                      </template>
                  </ul>
                  </div>
              </div>   
            </template>
            </div>    
            
           
         
         
          </div>
           <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideViewModal();  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
        </div> 
        </div>
        </modal> 
    
    <vs-popup class="holamundo main-popup"  :title="checkProperty(selectedItem,'status')?'Inactivate SOC Configuration':' Activate SOC Configaration'" :active.sync="deleteConformpopUp">
      <form @submit.prevent data-vv-scope="newSocform" >
        <div class="form-container">
          
          <div class="vx-row">
            <div class="vx-col w-full" v-if="checkProperty(selectedItem,'status') == false">
            <p>Are you sure of {{checkProperty(selectedItem,'status')?'Inactivate ':' Activate'}} this?</p>
              
            </div>
            <template v-if="checkProperty(selectedItem,'status')">
              <immiInput :fieldsArray="[]" :display="true"  cid="newSocCode" :wrapclass="'w-full'" 
              :formscope="'newSocform'" v-model="newSocCode" :required="true"
              :fieldName="'newSocCode'" label="New SOC Code" placeHolder="New SOC Code" :tplsection="'beneficiaryInfo'" />
            </template>
            
            
          </div>

          <div v-show="formerrors.msg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
        
        </div>
        <div class="popup-footer">
          <vs-button color="dark" class="cancel" type="filled" @click="deleteConformpopUp=false;newSocCode = ''">Cancel </vs-button>
          <vs-button color="success" class="save" type="filled" @click="deleteSoc(false)">{{checkProperty(this.selectedItem,'status')?'Submit ':' Activate'}}</vs-button>
        </div>
      </form>
    </vs-popup>
    
  </div>
</template>

<script> 
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";
import docType from "@/views/common/docType.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import immiInput from "@/views/forms/fields/simpleinput.vue";
import _ from "lodash";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";

//import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { MoreVerticalIcon } from "vue-feather-icons";
import NoDataFound from "@/views/common/noData.vue";
import Vue from 'vue'
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import VTooltip from 'v-tooltip'
import FileUpload from "@/views/FileUpload.vue";
Vue.use(VTooltip)

export default {
  provide() {
    return {
        parentValidator: this.$validator,
    };
  },
  computed: {
     acceptedFiles(){
      let returnValue ='*';
     
          returnValue ='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        

     
      return returnValue;
      //image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document
    }
    
  },
  components: {
    vsInvDropdown,
    immiInput,
    docType,
    NoDataFound,
    DateRangePicker,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    FileUpload,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    
  },

  data: () => ({
    newSocCode:'',
    editor: ClassicEditor,
    editorConfig: {
        toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
    },
    deleteConformpopUp:false,

    getInactiveListAlso:true,
    selectedStatus:null,
    statusList:[{ "id":true,   name:"Active", },{ "id":false,   name:"Inactive", }],

    value:[],
    uploading:false,
      allTags:[],
      creatingNew: false,
      masterSocList:[],
    
    callFromSerch: false,
    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    selectedItem: null,
   formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,

    newform: {name: "", 'designation':'',"jobTitles":'', description: "" ,socId:'' , socDetails:null },
    list: [],
    addPopup: false,
    searchtxt: "",
    query: [],
    

    date: "",
    date_range: [],
    page: 1,
      perPeges: [10,25,50,75,100],
      perpage: 25,
      totalCount:0,
      totalpages: 0,
     edit: false,
    sortKeys: {},
    sortKey: {},
    showSocDocs:false
    
  }),
  watch: {
    searchtxt: function (value) {
      let self =this;
      this.page = 1;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        self.getList(true);
      }, 900)
      
    },
  },
  methods: {
    updateData(docs){
      this.newform.document = docs
    },
    changeperPage(){
        this.page = 1;
        this.getList(true);
      },
    deleteSoc(action ,item){
      if(action){
        this.deleteConformpopUp =true;
        this.newSocCode = '';
        this.selectedItem = item;
        this.$validator.reset();
      }else{
        this.$validator.validateAll('newSocform').then(result => {
          if (result) {
            let postData ={
              "socCodeConfigId":'',
              status:false,
            }
            postData['status'] = this.checkProperty(this.selectedItem,'status')?false:true;
            if(this.checkProperty(this.selectedItem,'status')){
              postData['newSocCode'] = this.newSocCode;
            }
            postData['socCodeConfigId'] = this.selectedItem['_id'];
            let path ="/soc-code-config/manage-status";
            this.$store .dispatch("commonAction", {"data":postData ,"path":path}) .then(response => {
              this.deleteConformpopUp =false;
              //lca_request_msg
              this.getList();
              this.showToster({message:response.message,isError:false });
              this.selectedItem =null;
              this.newSocCode = '';
            })
            .catch((error)=>{
              Object.assign(this.formerrors, { msg: error});
              this.creatingNew = false;
            })
          }
      })
      }

      

    },
    showBulkUpload(){

      this.newform = { name: "",'designation':'',"jobTitles":'', description: "" ,socId:'' , socDetails:null ,document:[],"attachments":[] } ;
           this.value = [];
           this.edit =false;
           this.$validator.reset();
           this.addPopup =true;
          this.edit =false;
          this.creatingNew = false;
          this.$modal.show('socSettigsbulkUpload');
         Object.assign(this.formerrors, { msg: "" });
      
    },

    bulkUploadAction() {
     
     Object.assign(this.formerrors, { msg: "" });
     this.$validator.validateAll().then((result) => {
         if(result && this.checkProperty(this.newform ,'document' ,'length')>0){
              this.creatingNew = true;
            let  postData ={
              "socCodeConfigIds":[],
              "document":[]
            }
            postData['document'] =  _.cloneDeep(this.newform['document']);
        
          
         let   path ="/soc-code-config/update-documents";
              this.$store
             .dispatch("commonAction", {"data":postData ,"path":path})
             .then(response => {
              
               //lca_request_msg
                this.getList();
                this.showToster({message:response.message,isError:false });
                this.hideModel('socSettigsbulkUpload');
                 this.creatingNew = false;
               
                               
             })
             .catch((error)=>{
               Object.assign(this.formerrors, { msg: error});
                this.creatingNew = false;
             })
         }
     })
   
   },

    addSocCode() {
     
     Object.assign(this.formerrors, { msg: "" });
     this.$validator.validateAll().then((result) => {
         if(result){
              this.creatingNew = true;
            let  postData = _.cloneDeep(this.newform);
         //   postData  =Object.assign(postData,{ "socId": postData['socDetails']['id'] })
              this.$store
             .dispatch("commonAction", {"data":postData ,"path":"/soc-code-config/add-soc-code"})
             .then(response => {
              
               //lca_request_msg
                this.getList();
                this.showToster({message:response.message,isError:false });
                this.hideModel();
                 this.creatingNew = false;
               
                               
             })
             .catch((error)=>{
               Object.assign(this.formerrors, { msg: error});
                this.creatingNew = false;
             })
         }
     })
   
   },

     downloadFile(document){
      
       //alert(this.$globalgonfig._APIURL+"/common/viewfile?path="+document.path);
         window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+document.path, "_blank");
      },
      upload(files ,type="") {
        this.formerrors.msg ='';
        let self =this;
        let model = _.cloneDeep(files);
      //  this.value = [];
      // this.newform['document'] =null;
      // this.newform['attachments'] = [];


      let invaliedFiles =[];
      model.forEach(function (doc) {
          if(
           
            (
                doc.mimetype == "application/msword" ||  doc.type == "application/msword" ||
                doc.mimetype ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                doc.type ==  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            )
                  
            ){}else{
              invaliedFiles.push(doc);
            }

        });
        if(invaliedFiles.length>0){
         
          this.formerrors.msg ="Upload Only MS Word Files"
         // self.showToster({ message: "Upload Only MS Word Files ", isError: true });
          this.value =[] ;
          this.uploading=false
          return false;
        }

            var _current = this;
           // this.$vs.loading();
          
           
            let tempFiles =[]
            if (model.length > 0) {
                this.uploading =true;
                model.forEach((doc, index) => {
                    let formData = new FormData();                  
                    formData.append("files", doc.file);
                    formData.append("type", "forms-and-letters");
                    formData.append("secureType", "private");
                    formData.append("getDetails", true);
                    
                     //uploadLocal
                     //uploadS3File

                    this.$store.dispatch("uploadLocal", formData).then((response) => {
                        response.data.result.forEach((urlGenerated) => {
                            doc.url = urlGenerated;
                            delete doc.file;
                             let temp_file = urlGenerated;
                             
                           
                          tempFiles.push(temp_file);
                          let fl = { "name":temp_file['name'] ,"extn":temp_file['extn'] ,"path":temp_file['path'] , "mimetype":temp_file['mimetype'],
                          uploadedBy:this.checkProperty(this.getUserData,'userId'),
                          uploadedByName:this.checkProperty(this.getUserData,'name'),
                          uploadedByRoleId:this.getUserRoleId,
                          uploadedByRoleName:this.checkProperty(this.getUserData,'loginRoleName'),} ;
                          this.newform.document.push(fl);// =  urlGenerated ;
                          this.newform.attachments.push(fl);
                        
                         this.uploading =false;
                         this.$vs.loading.close();
                         if (tempFiles.length >= model.length) {
                              _current.$vs.loading.close();
                          }   
                       
                       });
                    
                    });

                 
               });
                
               
            }     
              //  model.splice(0, mapper.length, ...mapper);
            
    },
    remove(item, data ,filindex) {
            data.splice(filindex, 1);
          //  this.newform.document =null;
          this.removeFileFromS3(item)
    },
      showViewModal(item , showDocs){
            this.selectedItem =item
            this.showSocDocs = showDocs
             this.$modal.show('socSettingview');

      },
      hideViewModal(){
          this.$modal.hide('socSettingview');
      },
      getAvailableTages(){
          let query = {"category":"LETTER_VARIABLES"}
        this.$store.dispatch("commonAction", {"data":query ,"path":"/messages/list"})
        .then((response) => {
          this.allTags = this.checkProperty(response ,'messages' ,'LETTER_VARIABLES');
        }).catch((err) => {
          
          
        })
      },
      async  copyTag(text=''){
          
        try {
          await navigator.clipboard.writeText(text);
                   
        
        } catch ($e) {
         
        
        }
      
    
    },
      onSelectSoc(){

      },
      setNewForm(){
        
           this.newform = { name: "",'designation':'',"jobTitles":'', description: "" ,socId:'' , socDetails:null ,document:[],"attachments":[] } ;
           this.value = [];
           if(this.edit){
               
           }
           this.$validator.reset();
      },
      getMasterSocList(){

          let query = {};
            query["page"] = this.page;
            query["perpage"] = this.perpage;
            query["matcher"] = { };
            query["category"] = "soc_codes";
            query["sorting"] = this.sortKey;
            
      this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
          this.masterSocList = response.list;

        
          //alert(this.perpage);
        })
        .catch(() => {
          this.masterSocList = [];
         
        });

      },
      addNew(){
          this.setNewForm()
          this.addPopup =true;
          this.edit =false;
          this.creatingNew = false;
          this.$modal.show('socSettingModel');
         Object.assign(this.formerrors, { msg: "" });
         
      },
      hideModel(model='socSettingModel'){
          this.addPopup =false;
          this.edit =false;
          this.creatingNew = false;
         Object.assign(this.formerrors, { msg: "" });
         this.$modal.hide(model);
          this.setNewForm()

      },
    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = { path: sort_key, order: this.sortKeys[sort_key] };

        localStorage.setItem("userroles_sort_key", sort_key);
        localStorage.setItem("userroles_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    editMe(item) {
      this.setNewForm()
      this.edit = true;
    
      this.selectedItem = _.cloneDeep(item);
      Object.assign(this.formerrors, { msg: "" });
     //this.newform =_.cloneDeep( this.selectedItem);
     if(!(_.has(this.newform ,"document"))){

       this.newform = Object.assign( this.newform ,{ document:[] ,"attachments":[]})

     }else{
       this.newform = Object.assign( this.newform ,{ "attachments":[]})
       this.newform['attachments'] = [this.newform['document']]
     }
     this.value = this.newform['attachments'];
     this.newform['name'] = this.checkProperty(item, 'socDetails' ,'name');
     this.newform['description'] = this.checkProperty(item, 'socDetails' ,'description');
     this.newform['designation'] = this.checkProperty(item, 'socDetails' ,'designation');
     this.newform['jobTitles'] = this.checkProperty(item, 'socDetails' ,'jobTitles');
     this.newform['document'] = this.checkProperty(item, 'document');
     this.newform =_.cloneDeep( this.newform);
     this.value = this.checkProperty(this.newform, 'document')
     this.addPopup = false;
     this.creatingNew = false;
     this.$modal.show('socSettingModel');
    },

    

    createNewAction() {
     
      Object.assign(this.formerrors, { msg: "" });
      this.$validator.validateAll().then((result) => {
          if(result){
               this.creatingNew = true;
             let  postData = _.cloneDeep(this.newform);
           //  postData  =Object.assign(postData,{ "socId": postData['socDetails']['id'] })
             let path ="/soc-code-config/create";
             path ="/soc-code-config/add-soc-code";
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":path})
              .then(response => {
               
                //lca_request_msg
                 this.getList();
                 this.showToster({message:response.message,isError:false });
                 this.hideModel();
                  this.creatingNew = false;
                
                                
              })
              .catch((error)=>{
                Object.assign(this.formerrors, { msg: error});
                 this.creatingNew = false;
              })
          }
      })
    
    },

     updateAction() {
     
      Object.assign(this.formerrors, { msg: "" });
      this.$validator.validateAll().then((result) => {
          if(result){
               this.creatingNew = true;
             let  postData = _.cloneDeep(this.newform);
             postData['socCodeConfigId'] = this.selectedItem['_id'];
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/soc-code-config/update"})
              .then(response => {
               
                //lca_request_msg
               
                 this.showToster({message:response.message,isError:false });
                 this.hideModel();
                  this.creatingNew = false;
                  this.getList();
                
                                
              })
              .catch((error)=>{
                Object.assign(this.formerrors, { msg: error });
                 this.creatingNew = false;
              })
          }
      })
    
    },

     getDetails(action=false){
        let  postData ={'socCodeConfigId':''};
        postData['socCodeConfigId'] = this.checkProperty(this.selectedItem , '_id');
        this.$store
        .dispatch("commonAction", {"data":postData ,"path":"/soc-code-config/details"})
        .then(response => {
         
         if(action){
        
         }else{
          this.showToster({message:response.message,isError:false });
         }
       
                
                        
        })
        .catch((error)=>{
              this.showToster({message:error,isError:false });
        })
     
    
    },

    

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      if (this.callFromSerch) {
        this.list = [];
      }
      this.updateLoading(true);

      let matcher = {
        title: this.searchtxt,
        createdDateRange: [],
        statusList:[true],
      };
      matcher['statusList'] =[this.getInactiveListAlso];
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }

      let query = {};
      query["page"] = this.page;
      query["perpage"] = this.perpage;
      query["filters"] = matcher;
      query["sorting"] = this.sortKey;
   
     this.$store.dispatch("commonAction", {"data":query ,"path":"/soc-code-config/list"})
        .then((response) => {
          this.list = response.list;

          this.updateLoading(false);
          this.totalCount = this.checkProperty(response, 'totalCount');
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
          setTimeout(()=>{ 
            setTimeout(()=>{  this.updateLoading(false); } ,10);
            this.updateLoading(false); } ,10);
        })
        .catch(() => {
          this.list = [];
          this.updateLoading(false);
          setTimeout(()=>{
            setTimeout(()=>{  this.updateLoading(false); } ,10);
            this.updateLoading(false);
          } ,10);
        });
    },
 
    set_filter: function () {
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');

      if(this.selectedStatus){
        this.getInactiveListAlso = this.selectedStatus['id'];

      }
      
      this.getList(true);
    },
    clear_filter: function () {
      this.searchtxt = "";
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.selectedStatus =null;
      this.getInactiveListAlso =true;
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },

    
  },
  mounted() {
    
    let loginRoleId = this.getUserRoleId;
          this.allowed_roles = [2,3,4, 5, 6, 7, 8, 9, 10, 11,12,13];

    if (loginRoleId == 3) {
      this.allowed_roles = [4, 5, 6, 7, 8, 9, 10, 11, 13];
    }
    if (loginRoleId == 4) {
      this.allowed_roles = [5, 6, 7, 8, 9, 10, 11, 12];
    }
    if (this.$route.name != "basic-settings") {
      this.$store.dispatch("updateSidebarWidth", "extended");
    }
    //
  this.getMasterSocList();
  this.getAvailableTages();
    // this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];
    (this.sortKeys = {
      name: 1,
      type: 1,
      createdOn: -1,
      updatedOn: 1,
    }),
      (this.sortKey = { path: "createdOn", order: -1 });

    
    this.getList();
  },
};
</script>
